// extracted by mini-css-extract-plugin
module.exports = {"animatedCompetencyCard":"CompetencyCardAnimated_animatedCompetencyCard__n2j74","breathing":"CompetencyCardAnimated_breathing__VLpRg"};